export default __webpack_public_path__ + "static/media/pen-navbar.7b161475.svg";